<script type="ts">
    import { currentUser } from '../stores/user';
    import MyNemiSubscriptions from './MyNemiSubscriptions.svelte';
    import MyProfilePanel from './MyProfilePanel.svelte';
    import MyInvoices from './MyInvoices.svelte';

    let currentTab: 'subscriptions' | 'profile' | 'invoices' = 'profile';
</script>

<style>
    h2
    {
        text-transform: none;
        border-bottom: none;
    }
</style>

<div class="row">
    <div class="col-12">
        <h2> Bonjour {$currentUser.name}, Bienvenue dans votre espace My Nemi !</h2>
    </div>
    <div class="col-12">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a href={'#'} class="nav-link {currentTab === 'profile' ? 'active' : ''}" aria-current="page" on:click={() => currentTab = 'profile'}>Vos informations</a>
            </li>
            <li class="nav-item">
                <a href={'#'} class="nav-link {currentTab === 'subscriptions' ? 'active' : ''}" aria-current="page" on:click={() => currentTab = 'subscriptions'}>Vos abonnements</a>
            </li>
            <li class="nav-item">
                <a href={'#'} class="nav-link {currentTab === 'invoices' ? 'active' : ''}" aria-current="page" on:click={() => currentTab = 'invoices'}>Vos factures</a>
            </li>
        </ul>
        <div class="row pt-3"></div>

        {#if currentTab === 'subscriptions'}
            <MyNemiSubscriptions/>
        {/if}

        {#if currentTab === 'profile'}
            <MyProfilePanel/>
        {/if}

        {#if currentTab === 'invoices'}
            <MyInvoices/>
        {/if}
    </div>
</div>